import React from 'react';

import './style.scss';

const FullScreenLogo = () => {
  return (
    <div className="FullScreenLogo">
      <svg
        id="c"
        xmlns="http://www.w3.org/2000/svg"
        height="90"
        viewBox="0 0 1479.98 540.11"
        fill="#fc3c17"
      >
        <g>
          <path
            className="letter-1"
            d="m174.97,235.39v141.23h-37.38v-141.23h-38.08v-31.85h38.08v-9.35c0-45.35,24.92-64.04,59.19-64.04,11.08,0,20.08,1.38,30.12,2.77v34.62c-9.69-1.73-16.96-2.77-24.23-2.77-20.08,0-27.69,9.35-27.69,31.85v6.92h49.85v31.85h-49.85Z"
          />
          <path
            className="letter-2"
            d="m316.2,199.39c53.66,0,84.12,38.08,84.12,91.39v10.73h-132.92v.35c3.46,29.42,27,43.96,51.92,43.96,22.85,0,39.81-10.04,51.92-22.5l17.65,30.12c-14.19,13.84-36.69,27.35-69.23,27.35-55.38,0-90.35-36.69-90.35-90s33.58-91.39,86.89-91.39Zm43.27,73.73c-2.42-23.88-16.96-40.5-43.96-40.5s-43.27,15.23-47.77,40.5h91.73Z"
          />
          <path
            className="letter-3"
            d="m640.21,199.39c41.54,0,66.12,25.62,66.12,74.77v102.46h-37.73v-99.69c0-27.69-12.46-42.23-36-42.23-30.12,0-44.65,20.77-44.65,60.23v81.69h-37.38v-99.69c0-27.69-12.81-42.23-36.35-42.23-29.77,0-44.31,20.77-44.31,60.23v81.69h-37.38v-173.08h36.35v27c10.73-20.08,28.73-31.15,54.35-31.15s45.35,11.08,55.38,33.23c13.5-21.81,33.58-33.23,61.62-33.23Z"
          />
          <path
            className="letter-4"
            d="m846.87,373.51c-10.73,3.12-22.5,4.85-33.58,4.85-31.85,0-49.15-14.19-49.15-52.27v-90.69h-32.89v-31.85h32.89v-46.39h37.38v46.39h45.69v31.85h-45.69v88.27c0,12.12,5.19,18.35,18.69,18.35,9,0,15.58-1.04,26.65-2.77v34.27Z"
          />
          <path
            className="letter-5"
            d="m872.14,240.93c9-27,34.62-41.54,73.39-41.54,48.46,0,72.35,22.5,72.35,67.5v109.73h-37.38v-23.88c-11.77,17.65-31.15,28.04-55.04,28.04-34.96,0-58.5-22.5-58.5-54.35,0-29.77,21.12-50.54,55.39-53.65l48.12-4.85c7.27-.69,10.04-3.12,10.04-7.96v-3.81c0-14.54-12.46-23.19-34.27-23.19-23.88,0-39.81,10.04-43.96,27l-30.12-19.04Zm108.35,55.73l-49.85,6.23c-15.92,1.73-24.92,10.04-24.92,22.5,0,13.85,10.73,22.5,28.38,22.5,26.31,0,46.39-18.35,46.39-41.19v-10.04Z"
          />
          <path
            className="letter-6"
            d="m1122.07,199.39c31.15,0,53.66,11.08,68.54,31.85l-25.27,23.88c-9.35-14.19-26.65-21.46-46.04-21.46-17.31,0-28.04,6.23-28.04,17.31,0,11.77,11.42,14.54,40.85,21.46,34.61,8.31,58.85,18.35,58.85,53.31s-25.62,55.04-70.27,55.04c-35.31,0-63.35-12.81-76.85-34.96l25.62-24.58c10.04,15.58,28.04,25.61,54,25.61,18.35,0,29.42-6.23,29.42-19.04s-10.73-15.58-38.42-21.81c-29.77-6.58-61.27-16.96-61.27-53.65,0-32.89,26.31-52.96,68.88-52.96Z"
          />
          <path
            className="letter-7"
            d="m1230.76,445.86l42.58-93.12-74.43-149.19h44.31l49.85,105.58,48.46-105.58h39.81l-110.77,242.31h-39.81Z"
          />
        </g>
      </svg>
    </div>
  );
};

export default FullScreenLogo;
